import React from "react";

const ExploreJobCardSkeleton = () => {
  return (
    <div className="flex flex-col w-full p-4 sm:p-6 bg-white rounded-xl border border-light-blue md:flex-row md:items-stretch justify-between animate-pulse">
      {/* Image placeholder */}
      <div className="w-full md:w-[200px] h-[150px] md:h-[200px] md:flex-shrink-0 overflow-hidden rounded-[4px] mb-5 md:mb-0 bg-gray-200"></div>

      {/* Content area */}
      <div className="flex-1 flex flex-col justify-between md:pl-4">
        {/* Time indicator - mobile only */}
        <div className="sm:hidden block">
          <div className="h-6 bg-gray-200 rounded w-24"></div>
        </div>

        {/* Title and location section */}
        <div className="flex flex-row items-start justify-between mt-2 sm:mt-0">
          <div className="w-3/4">
            <div className="h-6 bg-gray-200 rounded w-full mb-1"></div>
            <div className="h-5 bg-gray-200 rounded w-1/2"></div>
          </div>
          {/* Time indicator - desktop only */}
          <div className="hidden sm:block">
            <div className="h-6 bg-gray-200 rounded w-24"></div>
          </div>
        </div>

        {/* Date, time section */}
        <div className="mt-2 flex flex-row gap-16">
          <div className="flex flex-col gap-1">
            <div className="h-6 bg-gray-200 rounded w-12"></div>
            <div className="h-6 bg-gray-200 rounded w-24"></div>
          </div>
          <div className="flex flex-col gap-1">
            <div className="h-6 bg-gray-200 rounded w-12"></div>
            <div className="h-6 bg-gray-200 rounded w-16"></div>
          </div>
        </div>

        {/* Category, skills and button section */}
        <div className="mt-2 md:mt-auto flex flex-col md:flex-row md:items-end md:justify-between">
          {/* Category, skill */}
          <div className="mt-2 flex flex-wrap gap-2">
            <div className="flex flex-col gap-1">
              <div className="h-6 bg-gray-200 rounded w-20 mb-2"></div>
              <div className="h-11 bg-gray-200 rounded-[20px] w-28"></div>
            </div>
            <div className="flex flex-col gap-1">
              <div className="h-6 bg-gray-200 rounded w-16 mb-2"></div>
              <div className="h-11 bg-gray-200 rounded-[20px] w-36"></div>
            </div>
          </div>

          {/* Button */}
          <div className="mt-5 w-full md:w-auto mx-auto md:mx-0 md:mt-0 md:ml-auto">
            <div className="h-[49px] bg-gray-200 rounded-xl w-full md:w-[214px]"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExploreJobCardSkeleton;
